import CategoryDetail from "./CategoryDetail"

export default  CategoryDetail;
